module.exports = __webpack_public_path__ + "assets/img/7c7fd2dfdc257cefe437b7becf33d6a7.png";